import React from 'react'
import Button from '@material-ui/core/Button';
import { TopToolbar, Link } from 'react-admin';
import EditIcon from '@material-ui/icons/Edit';
import ContactListExportButton from './ContactListExportButton'

const CustomShowActions = (props) => {
    const { basePath, data, resource, overrideOrgID } = props
    let elem, orgID
    if (data) {
        if (overrideOrgID) orgID = overrideOrgID
        else if (data.org_id) orgID = data.org_id
        else if (data.OrganizationId) orgID = data.OrganizationId
        elem = (
            <TopToolbar>
                <Button
                    style={{
                        fontSize: '10',
                        color: "#03a9f4",
                    }}
                    component={Link}
                    to={{
                        pathname: `/${resource}/${data.id}/edit`,
                        search: `organization_id=${orgID}`,
                    }}>
                    Edit
            <EditIcon />
                </Button>
                {props.basePath === '/contactlists' && <ContactListExportButton {...props}/>}
            </TopToolbar>
        )
    } else { elem = (<div />) }
    return elem
}

export default CustomShowActions